import React from 'react';
import {Plugins, withSystem} from '@packages/systems/wfdl';
import {excludeSearchByDefaultType} from '@packages/systems/search';
import {
  TRecord,
  TText,
  TBoolean,
  TTypeConstructor,
} from '@packages/systems/wfdl-ast';
import {createDevLinkRootAlias} from '@packages/utilities/integrated-types';
import {
  extendExpressionEditorActionAtPath,
  ExpressionEditor,
} from '@packages/systems/ExpressionEditor-utils';
import {qualify, typeName} from '@packages/systems/wfdl-Qualified';

import {ContextualExpressions} from '@packages/utilities/contextual-expression';

const codePropTypeName = qualify(Plugins.name('Embed'), typeName('CodeProp'));

const EmbedPluginType = createDevLinkRootAlias({
  params: ['extraAtomFields'],
  fields: {
    search: withSystem(
      {private: true},
      TRecord({
        exclude: excludeSearchByDefaultType,
      })
    ),
    embed: TRecord({
      meta: TRecord({
        html: TText,
        div: TBoolean,
        script: TBoolean,
        compilable: TBoolean,
        iframe: TBoolean,
      }),
      type: TText,
    }),
    insideRTE: TBoolean,
    value: TText,
    content: withSystem(
      {
        isBindable: true,
        isLocalizable: true,
        label: 'Code',
        displayName: 'Code',
      },
      TTypeConstructor(codePropTypeName)
    ),
  },
  render: function EmbedTypeRender({expr, dispatch}) {
    const contentExpr = ContextualExpressions.getIn(expr, [
      {in: 'Record', at: 'content'},
    ]);

    const contentDispatch = React.useMemo(
      () =>
        extendExpressionEditorActionAtPath(dispatch)([
          {in: 'Record', at: 'content'},
        ]),
      [dispatch]
    );

    // This should never happen, but if it does, it is better than
    // showing all Embed fields.
    if (!contentExpr) return null;

    return (
      <div data-automation-id="EmbedSettingsAlias">
        <ExpressionEditor expression={contentExpr} dispatch={contentDispatch} />
      </div>
    );
  },
});

export default EmbedPluginType;
